module.exports = __webpack_public_path__ + "x_icon.png?e6eda3a2473f631e30e7adcd764a7173";


//////////////////
// WEBPACK FOOTER
// ./src/assets/x_icon.png
// module id = 144
// module chunks = 0